import styled from 'styled-components'

export const PeopleRentContractWrap = styled.div``
